import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminSizeGuide } from "@/components/admin/AdminSizeGuide";

export const AdminGear = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/gear/waitlist").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="admin-gear">
      <AdminSizeGuide />
      <p className="text-sm text-slate-600 mb-4">Clientes apuntados a la lista de espera de FAUNNY GEAR (se les avisa por email del lanzamiento): <strong data-testid="admin-gear-count">{rows.length}</strong></p>
      <div className="border border-slate-200 rounded divide-y">
        {rows.map((r) => (
          <div key={r.email} className="flex justify-between gap-4 px-4 py-3 text-sm" data-testid={`admin-gear-row-${r.email}`}>
            <span className="font-medium">{r.email}</span>
            <span className="text-slate-500">{(r.products || []).join(", ")} · {new Date(r.created_at).toLocaleDateString("es-ES")}{r.notified_at ? " · Avisado" : " · Pendiente de aviso"}</span>
          </div>
        ))}
        {!rows.length && <p className="px-4 py-6 text-sm text-slate-500">Todavía no hay nadie apuntado.</p>}
      </div>
    </div>
  );
};
